/* eslint-disable comma-dangle */
import _ from 'lodash';
import { useForm } from 'react-final-form';
import { useEffect, useMemo } from 'react';
import { Grid, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import QCXFinalCheckboxField from '../../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalPercentualField from '../../../shared-components/final-percentual-field/QCXFinalPercentualField';
import QCXFinalAlternativeCurrencyField from '../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectTipoRetencaoAutocomplete from '../../../shared-components/select-tipo-retencao/QCXSelectTipoRetencaoAutocomplete';
import QCXSelectTipoIssAutocomplete from '../../../shared-components/select-tipo-iss/QCXSelectTipoIssAutocomplete';
import { BRAZILIAN } from '../../../utils/hooks/form/field/mask-types';

export default function QCXClienteServicoRetencaoImpostoForm({ servicos, modes }) {
  const { t } = useTranslation();
  const form = useForm();
  const { values } = form.getState();

  /* serviço selecionado ---------------------------------------------- */
  const codServico = _.get(values, 'servico.id');
  const servico = servicos.find((s) => s.id === codServico);
  const boxKey = servico?.id ?? 'no-service';

  /* onde ficam as relações normalizadas ------------------------------ */
  const listRootName = `clienteServicoRetencaoImpostoByServicoId.${servico?.code || ''}`;

  const RET_KEYS = [
    // percentuais
    'aliquotaPis', 'aliquotaCofins', 'aliquotaCsll',
    'aliquotaIss', 'aliquotaIr',
    // valores mínimos
    'valorMinimo', 'valorMinimoIr',
    // check‑boxes
    'reter', 'reterIr',
    // tipos
    'tipoRetencao', 'tipoRetencaoIr',
    'tipoIss', 'tipoIr',
  ];

  /* sempre que muda o serviço ---------------------------------------- */
  useEffect(() => {
    /* 1. limpa TODAS as chaves filhas ----------------------------- */
    form.batch(() => {
      RET_KEYS.forEach((k) =>
        form.change(`ignorableFields.retencao.${k}`, undefined)
      );
    });

    /* 2. procura o vínculo do serviço (se houver) ----------------- */
    if (!servico) return;

    let regList = _.get(form.getState().values, listRootName) || [];

    if (!regList.length) {
      const flat = form.getState().values?.relacaoClienteServicoRetencoesImpostos || [];
      regList = flat.filter((r) => r?.servico?.id === servico.id);
    }

    /* 3. grava o vínculo encontrado ------------------------------- */
    if (regList.length) {
      form.change('ignorableFields.retencao', regList[0]);
    }
  }, [servico, listRootName, form]);

  /* ------------------------------------------------------------------ */
  const campoPct = (nome, lbl) => (
    <Grid item sm={2} key={nome}>
      <QCXFinalPercentualField
        name={`ignorableFields.retencao.${nome}`}
        label={lbl}
        scale={7}
        disabled={modes?.isConsult}
      />
    </Grid>
  );

  return (
    <Box key={boxKey} style={{ pointerEvents: modes?.isConsult ? 'none' : '' }}>
      <Grid container spacing={2}>
        {campoPct('aliquotaPis', '% PIS')}
        {campoPct('aliquotaCofins', '% COFINS')}
        {campoPct('aliquotaCsll', '% CSLL')}

        <Grid item sm={2}>
          <QCXFinalAlternativeCurrencyField
            name="ignorableFields.retencao.valorMinimo"
            label={t('com.muralis.qcx.valorMinimo')}
            intl={BRAZILIAN}
            disabled={modes?.isConsult}
          />
        </Grid>

        <Grid item sm={2}>
          <QCXSelectTipoRetencaoAutocomplete
            name="ignorableFields.retencao.tipoRetencao"
            label='MODALIDADE DE RETENÇÃO'
            disabled={modes?.isConsult}
          />
        </Grid>

        <Grid item sm={2}>
          <QCXFinalCheckboxField
            name="ignorableFields.retencao.reter"
            label={t('com.muralis.qcx.reterAbaixoValorMinimo')}
            value="RETER"
            disabled={modes?.isConsult}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 8 }}>
        {campoPct('aliquotaIr', '% IR')}

        <Grid item sm={2}>
          <QCXFinalAlternativeCurrencyField
            name="ignorableFields.retencao.valorMinimoIr"
            label={`${t('com.muralis.qcx.valorMinimo')} - IR`}
            intl={BRAZILIAN}
            disabled={modes?.isConsult}
          />
        </Grid>

        <Grid item sm={2}>
          <QCXSelectTipoRetencaoAutocomplete
            name="ignorableFields.retencao.tipoRetencaoIr"
            label=  'MODALIDADE DE RETENÇÃO - IR'
            disabled={modes?.isConsult}
          />
        </Grid>

        <Grid item sm={2}>
          <QCXSelectTipoIssAutocomplete   /* usa lista de tipos‑IR */
            name="ignorableFields.retencao.tipoIr"
            label="Tipo IR"
            disabled={modes?.isConsult}
          />
        </Grid>

        <Grid item sm={2}>
          <QCXFinalCheckboxField
            name="ignorableFields.retencao.reterIr"
            label={`${t('com.muralis.qcx.reterAbaixoValorMinimo')} - IR`}
            value="RETER"
            disabled={modes?.isConsult}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 8 }}>
        {campoPct('aliquotaIss', '% ISS')}

        <Grid item sm={2}>
          <QCXSelectTipoIssAutocomplete
            name="ignorableFields.retencao.tipoIss"
            label="Tipo ISS"
            disabled={modes?.isConsult}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

